module.exports = __webpack_public_path__ + "static/media/print.c5b8062b.svg";